import React, { useState, useEffect } from 'react';
import './App.css';
import TaxCalculator from './components/TaxCalculator';
import { FaMoon, FaSun } from 'react-icons/fa';

// Create dark mode context
export const ThemeContext = React.createContext({
  darkMode: false,
  toggleDarkMode: () => {}
});

function App() {
  // Initialize dark mode from localStorage or default to false
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved !== null ? JSON.parse(saved) : false;
  });

  // Toggle dark mode and store preference
  const toggleDarkMode = () => {
    setDarkMode(prevMode => !prevMode);
  };

  // Update localStorage and document class when dark mode changes
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <div className={`App ${darkMode ? 'dark-mode' : ''}`}>
        <header className="App-header">
          <div className="header-content">
            <h1>NJ Sales Tax Calculator 2024</h1>
            <button 
              className="theme-toggle" 
              onClick={toggleDarkMode}
              aria-label="Toggle dark mode"
            >
              {darkMode ? <FaSun /> : <FaMoon />}
            </button>
          </div>
        </header>
        <main>
          <TaxCalculator />
        </main>
        <footer>
          <p>Current NJ Sales Tax Rate: 6.625% • Updated for 2024</p>
        </footer>
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
